@if (exploreShouldBeVisible) {
  <div class="details-card-wrapper">
    <!-- heading -->
    <h2>Explore</h2>

    <div class="details-card">
      <div class="details-card-body">
        <div class="row">
          @for (scrollAbleSection of ScrollAbleSections; track scrollAbleSection) {
            @switch (scrollAbleSection.value) {
              @case (ScrollAbleSectionIds.Description) {
                @if (product?.short_description) {
                  <base-explore-button
                    class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-16 pb-16 ps-0"
                    [label]="scrollAbleSection.viewValue"
                    (click)="scrollToSection(scrollAbleSection.value)"
                  ></base-explore-button>
                }
              }
              @case (ScrollAbleSectionIds.SimilarProducts) {
                @if (productStateManager?.similarProducts?.()?.length) {
                  <base-explore-button
                    class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-16 pb-16 ps-0"
                    [label]="scrollAbleSection.viewValue"
                    (click)="scrollToSection(scrollAbleSection.value)"
                  ></base-explore-button>
                }
              }
              @case (ScrollAbleSectionIds.Accessories) {
                @if (productStateManager?.accessories?.()?.length) {
                  <base-explore-button
                    class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-16 pb-16 ps-0"
                    [label]="scrollAbleSection.viewValue"
                    (click)="scrollToSection(scrollAbleSection.value)"
                  ></base-explore-button>
                }
              }
              @case (ScrollAbleSectionIds.Specifications) {
                @if (product.specifications?.length) {
                  <base-explore-button
                    class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-16 pb-16 ps-0"
                    [label]="scrollAbleSection.viewValue"
                    (click)="scrollToSection(scrollAbleSection.value)"
                  ></base-explore-button>
                }
              }
              @case (ScrollAbleSectionIds.ProductsInBox) {
                @if (productStateManager?.productsInABox?.()?.length) {
                  <base-explore-button
                    class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-16 pb-16 ps-0"
                    [label]="scrollAbleSection.viewValue"
                    (click)="scrollToSection(scrollAbleSection.value)"
                  ></base-explore-button>
                }
              }
              @case (ScrollAbleSectionIds.Features) {
                @if (productStateManager?.features?.()?.length) {
                  <base-explore-button
                    class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-16 pb-16 ps-0"
                    [label]="scrollAbleSection.viewValue"
                    (click)="scrollToSection(scrollAbleSection.value)"
                  ></base-explore-button>
                }
              }
              @case (ScrollAbleSectionIds.Downloads) {
                @if (
                  productStateManager?.downloads?.() &&
                  (productStateManager?.downloads?.()?.catalog?.length ||
                    productStateManager?.downloads?.()?.howToGuide?.length ||
                    productStateManager?.downloads?.()?.price_list?.length ||
                    productStateManager?.downloads?.()?.user_manuals?.length)
                ) {
                  <base-explore-button
                    class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-16 pb-16 ps-0"
                    [label]="scrollAbleSection.viewValue"
                    (click)="scrollToSection(scrollAbleSection.value)"
                  ></base-explore-button>
                }
              }
              @case (ScrollAbleSectionIds.SponsoredProducts) {
                @if (productStateManager?.sponsoredProducts?.()?.length) {
                  <base-explore-button
                    class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-16 pb-16 ps-0"
                    [label]="scrollAbleSection.viewValue"
                    (click)="scrollToSection(scrollAbleSection.value)"
                  ></base-explore-button>
                }
              }
              @case (ScrollAbleSectionIds.FrequentlyBoughtToTogether) {
                @if (productStateManager?.frequentlyBoughtTogether?.()?.length) {
                  <base-explore-button
                    class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-16 pb-16 ps-0"
                    [label]="scrollAbleSection.viewValue"
                    (click)="scrollToSection(scrollAbleSection.value)"
                  ></base-explore-button>
                }
              }
              @case (ScrollAbleSectionIds.Images) {
                @if (
                  productStateManager?.assets?.()?.images &&
                  (productStateManager?.assets?.()?.images?.featuredImages?.length ||
                    productStateManager?.assets?.()?.images?.feature?.length ||
                    productStateManager?.assets?.()?.images?.others?.length)
                ) {
                  <!-- Debug: Images data: {{ productStateManager?.assets?.() | json }} -->
                  <base-explore-button
                    class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-16 pb-16 ps-0"
                    [label]="scrollAbleSection.viewValue"
                    (click)="scrollToSection(scrollAbleSection.value)"
                  ></base-explore-button>
                }
              }
              @case (ScrollAbleSectionIds.Videos) {
                @if (productStateManager?.assets?.()?.videos?.featured?.length) {
                  <!-- Debug: Videos data: {{ productStateManager?.assets?.()?.videos | json }} -->
                  <base-explore-button
                    class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-16 pb-16 ps-0"
                    [label]="scrollAbleSection.viewValue"
                    (click)="scrollToSection(scrollAbleSection.value)"
                  ></base-explore-button>
                }
              }
              @default {
                <base-explore-button
                  class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pr-16 pb-16 ps-0"
                  [label]="scrollAbleSection.viewValue"
                  (click)="scrollToSection(scrollAbleSection.value)"
                ></base-explore-button>
              }
            }
          }
        </div>
      </div>
    </div>
  </div>
}
